const initialState = {
  foundationConnectionDetails: {}
};

const foundationConnectionDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'foundationConnectionDetails':
      return {
        ...state,
        foundationConnectionDetails: action.payload
      };

    default:
      return state;
  }
};

export default foundationConnectionDetailsReducer;
